import * as React from 'react';
const IconDirectionContext = React.createContext(undefined);
const IconDirectionContextDefaultValue = {};
export const IconDirectionContextProvider = IconDirectionContext.Provider;
export const useIconContext = () => React.useContext(IconDirectionContext) ? React.useContext(IconDirectionContext) : IconDirectionContextDefaultValue;